import { jsxs as O, jsx as e } from "react/jsx-runtime";
import { useReducer as d, useState as R } from "react";
import { TrailerRentalCancellationReducer as B, InitialTrailerRentalCancellationState as b } from "../../../state/trailer-rental-cancellation-reducer.js";
import L from "./trailer-rental-cancellation-block.module.less.js";
import { Drawer as A } from "../../../../../components/elements/drawer/drawer.js";
import { SubmitBookingNumber as M } from "../../elements/submit-booking-number/submit-booking-number.js";
import { CancellationCompleted as D } from "../../elements/cancellation-completed/cancellation-completed.js";
import { ConfirmCancellation as S } from "../../elements/confirm-cancellation/confirm-cancellation.js";
import { useGetTrailerBookingInformation as G } from "../../../react-query-queries/use-get-trailer-booking-information.js";
import { useDeleteTrailerRentalBooking as h } from "../../../react-query-queries/use-delete-trailer-rental-booking.js";
import n from "dayjs";
import { useTranslation as Y } from "react-i18next";
import "../../../../../contexts/global-context.js";
import "motion/react";
import "../../../../../components/elements/button/button.js";
import "@radix-ui/react-dialog";
import "@radix-ui/react-accordion";
import "@vis.gl/react-google-maps";
import "haversine-distance";
import "usehooks-ts";
import "react-countup";
import "embla-carousel-react";
import "react-loading-skeleton";
/* empty css                                                                   */
import "@tanstack/react-query";
import "lodash-es";
import "../../../../../components/form-elements/input/input.js";
import "react-hook-form";
import "../../../../../components/form-elements/file-upload/file-upload.js";
import "../../../../../components/form-elements/select/select.js";
import "@radix-ui/react-slider";
import "../../../../../components/blocks/customer-service/company-forms.js";
import "../../../../../labels/i18n.js";
import "body-scroll-lock";
import "@radix-ui/react-visually-hidden";
import y from "../../../../../events/event-aggregator.js";
import { EVENT as F } from "../../../../../events/event.js";
import "supercluster";
/* empty css                                */
const Ro = ({
  title: s,
  premable: p,
  cancellationCompletedLink: c
}) => {
  const [o, m] = d(B, {
    ...b,
    step: "SUBMIT_BOOKING_NUMBER"
  }), [t, l] = R(), {
    isLoading: g,
    error: k,
    refetch: u
  } = G(t ?? ""), {
    isSuccess: K,
    error: N,
    isPending: T,
    mutateAsync: f
  } = h(t ?? ""), C = () => {
    t && f(t).then(() => {
      y.publish(F.TRACK_EVENT, {
        event: "cancel_trailer_success",
        station: o.booking?.locationName,
        pickup_date: n(o.booking?.pickupTime).format("YYYY-MM-DD"),
        return_date: n(o.booking?.returnTime).format("YYYY-MM-DD"),
        // trailer_type: UNAVAILABLE in booking object
        // est_price: UNAVAILABLE in booking object
        // final_price: UNAVAILABLE in booking object
        pickup_time: n(o.booking?.pickupTime).format("HH:mm"),
        return_time: n(o.booking?.returnTime).format("HH:mm")
      }), m({ type: "CANCELLATION_COMPLETED" });
    }).catch((i) => ({ text: "Ett fel uppstod, kunde inte slutföra avbokning." }));
  }, I = () => {
    u().then((i) => {
      const { data: r } = i;
      r && m({ type: "SET_BOOKING_INFORMATION", payload: { booking: r } });
    });
  }, _ = () => {
    m({
      type: "CLEAR_BOOKING_INFORMATION"
    });
  }, E = (i) => {
    const { t: r } = Y();
    switch (i) {
      case "SUBMIT_BOOKING_NUMBER":
      case "CONFIRM_CANCELLATION":
        return /* @__PURE__ */ e(
          M,
          {
            title: s,
            preamble: p,
            errorMessageGetBookingNumber: k ? { text: r("TRAILER_RENTAL_ERROR_GET_BOOKING_FAILED") } : void 0,
            errorMessageGetCancelBooking: N ? { text: r("TRAILER_RENTAL_ERROR_POST_BOOKING_CANCELLATION_FAILED") } : void 0,
            onSubmit: I,
            isLoading: g,
            bookingNumber: t,
            setBookingNumber: l
          }
        );
      case "CANCELLATION_COMPLETED":
        return /* @__PURE__ */ e(
          D,
          {
            cancellationCompletedLink: c,
            bookingId: o.booking?.bookingId?.toString() ?? ""
          }
        );
    }
  }, a = o.step === "CONFIRM_CANCELLATION";
  return /* @__PURE__ */ O("section", { className: L.section, children: [
    E(o.step),
    /* @__PURE__ */ e(A, { isOpen: a, anchor: "bottom", children: a && o.booking && /* @__PURE__ */ e(
      S,
      {
        onConfirm: C,
        isLoadingCancellation: T,
        onCloseDrawer: _,
        booking: o.booking
      }
    ) })
  ] });
};
export {
  Ro as TrailerRentalCancellationBlock,
  Ro as default
};
